import { z } from 'zod'

export const UpdateDeviceConfigMutationVariablesSchema = z.object({
    device_uuid: z.string(),
    // Upstream codegen types this as `Scalars['json']` (i.e. `any`); kept loose to match.
    diff_config: z.any(),
    timestamp: z.string()
})

export type UpdateDeviceConfigMutationVariables = z.infer<typeof UpdateDeviceConfigMutationVariablesSchema>

export const SetDeviceForceUpdateMutationVariablesSchema = z.object({
    device_uuid: z.string()
})

export type SetDeviceForceUpdateMutationVariables = z.infer<typeof SetDeviceForceUpdateMutationVariablesSchema>

export const GetDeviceUuidsQuerySchema = z.object({
    __typename: z.literal('query_root').optional(),
    device: z.array(
        z.object({
            __typename: z.literal('device').optional(),
            uuid: z.string(),
            device_name: z.string().nullish(),
            type: z.string().nullish()
        })
    )
})

export type GetDeviceUuidsQuery = z.infer<typeof GetDeviceUuidsQuerySchema>

export const GetDeviceDataQuerySchema = z.object({
    __typename: z.literal('query_root').optional(),
    device: z.array(
        z.object({
            __typename: z.literal('device').optional(),
            uuid: z.string(),
            type: z.string().nullish(),
            device_name: z.string().nullish(),
            config_error: z.string().nullish(),
            config_force_update: z.boolean().nullish(),
            config_current_timestamp: z.string().nullish(),
            config_target_timestamp: z.string().nullish(),
            // Upstream codegen types this as `Scalars['json']` (i.e. `any`); kept loose to match.
            config: z.any().optional()
        })
    )
})

export type GetDeviceDataQuery = z.infer<typeof GetDeviceDataQuerySchema>

export const UpdateDeviceConfigMutationSchema = z.object({
    message: z.string()
})

export type UpdateDeviceConfigMutation = z.infer<typeof UpdateDeviceConfigMutationSchema>

export const SetDeviceForceUpdateMutationSchema = z.object({
    message: z.string()
})

export type SetDeviceForceUpdateMutation = z.infer<typeof SetDeviceForceUpdateMutationSchema>

export const GetSmsStatusVariablesSchema = z.object({
    device_uuid: z.string()
})

export type GetSmsStatusVariables = z.infer<typeof GetSmsStatusVariablesSchema>

export const SendSmsCommandVariablesSchema = z.object({
    device_uuid: z.string(),
    command: z.string()
})

export type SendSmsCommandVariables = z.infer<typeof SendSmsCommandVariablesSchema>

export const GetSmsStatusQuerySchema = z.array(
    z.object({
        date: z.string().nullish(),
        content: z.string().nullish(),
        delivery_status: z.string().nullish()
    })
)

export type GetSmsStatusQuery = z.infer<typeof GetSmsStatusQuerySchema>

export const SendSmsCommandMutationSchema = z.object({
    message: z.string()
})

export type SendSmsCommandMutation = z.infer<typeof SendSmsCommandMutationSchema>
